import { apiGet } from '../../api'

export const all_documents = query => {
  return apiGet({
    endpoint: `documents/all_documents?${query}`
  })
}
